/**
 * Login page help videos — add MP4s under client/public/help-videos/ so they are served as /help-videos/<filename>.
 *
 * Optional: set REACT_APP_HELP_VIDEO_CACHE_KEY (e.g. 2) when you replace an MP4, then rebuild, so browsers skip a stale cached file.
 *
 * After adding a file, run `npm run build` so it is copied into build/help-videos/ for production.
 * Filenames must match exactly (Linux servers are case-sensitive): e.g. how-to-log-in.mp4
 */

/**
 * Resolves a URL under the CRA public folder (supports homepage / PUBLIC_URL subpaths).
 * @param {string} path - e.g. '/help-videos/how-to-log-in.mp4'
 */
export function publicHelpAssetUrl(path) {
  const rel = path.startsWith('/') ? path : `/${path}`;
  const base = (process.env.PUBLIC_URL || '').replace(/\/$/, '');
  const ver = process.env.REACT_APP_HELP_VIDEO_CACHE_KEY;
  const suffix = ver ? `?v=${encodeURIComponent(ver)}` : '';
  return `${base}${rel}${suffix}`;
}

export const LOGIN_HELP_VIDEOS = [
  {
    id: 'login-help',
    title: 'How to log in',
    src: publicHelpAssetUrl('/help-videos/how-to-log-in.mp4'),
    thumbnail: null,
    comingSoon: false,
  },
];
